import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=7d913e01&scoped=true&"
import script from "./SquareButton.vue?vue&type=script&lang=js&"
export * from "./SquareButton.vue?vue&type=script&lang=js&"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=7d913e01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d913e01",
  null
  
)

export default component.exports